import styled from '@emotion/styled'

export const PaymentMethods = styled.div`
  padding: 10px 0;
`
